module.exports = __webpack_public_path__ + "img/soil-normal.7b042f0f.png";